module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control button has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\"\r\n         style=\"width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; background-color: #ffffff; color: #000000;\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border-radius: 0px;\r\n                border: solid ")
    ; __append(escapeFn(borderColor))
    ; __append(" 1px;\">\r\n        <style>\r\n            #")
    ; __append(escapeFn(id))
    ; __append(" table{ height:100%;}\r\n            #")
    ; __append(escapeFn(id))
    ; __append(" tr {height: 30px;}\r\n            #")
    ; __append(escapeFn(id))
    ; __append(" th {\r\n                border: 1px solid #ccc; \r\n                color: ")
    ; __append(escapeFn( headerTextColor ))
    ; __append(";\r\n                font-family: '")
    ; __append(escapeFn( headerFontFamily ))
    ; __append("';\r\n                font-size: ")
    ; __append(escapeFn( headerFontSize ))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(headerTextStyle))
    ; __append(";\r\n                font-weight: ")
    ; __append(escapeFn(headerTextWeight))
    ; __append(";\r\n                padding-left:3px; \r\n                width:42px; \r\n                text-align:center;\r\n            }\r\n            #")
    ; __append(escapeFn(id))
    ; __append(" td {\r\n                border-right: 1px solid #ccc; \r\n                color: ")
    ; __append(escapeFn( styleColorText ))
    ; __append(";\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                font-size: ")
    ; __append(escapeFn( fontSize ))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                padding-left:3px; \r\n                height:30px; \r\n                width:42px\r\n            }\r\n            #")
    ; __append(escapeFn(id))
    ; __append(" tfoot td{height:110px}\r\n        </style>\r\n        <table style=\"width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\">\r\n            <thead>\r\n                <tr style=\"background-color: ")
    ; __append(escapeFn( headerBgColor ))
    ; __append("\">\r\n                    <th style=\"width:71px\"></th>\r\n                    <th>Jan</th>\r\n                    <th>Feb</th>\r\n                    <th>Mar</th>\r\n                    <th>Apr</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr style=\"background-color: ")
    ; __append(escapeFn( normalRowBgColor ))
    ; __append("\">\r\n                    <td>Item 1</td>\r\n                    <td>10</td>\r\n                    <td>20</td>\r\n                    <td>14</td>\r\n                    <td>19</td>\r\n                </tr>\r\n                <tr style=\"background-color: ")
    ; __append(escapeFn( alternateRowBgColor ))
    ; __append("\">\r\n                    <td>Item 2</td>\r\n                    <td>10</td>\r\n                    <td>30</td>\r\n                    <td>14</td>\r\n                    <td>19</td>\r\n                </tr>\r\n            </tbody>\r\n            <tfoot>\r\n                <tr>\r\n                    <td></td>\r\n                    <td></td>\r\n                    <td></td>\r\n                    <td></td>\r\n                    <td></td>\r\n                </tr>\r\n            </tfoot>\r\n        </table>\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}